import { get, keys, flow, pickBy, isEqual } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getPageLayout = get('components.reports.pageLayout');

export const getSidebarNavExpanded = createSelector(
  getPageLayout,
  get('sidebarNavExpanded')
);

export const getDropdownNavItemsExpanded = createSelector(
  getPageLayout,
  get('dropdownNavItemsExpanded')
);

export const getDropdownNavOpenKeys = createSelector(
  getDropdownNavItemsExpanded,
  flow(
    pickBy(isEqual(true)),
    keys
  )
);
